
import LogoGym from '../../Logo/LogoGym'
export default {
  name: 'BannerLogo',
  components: { LogoGym },
}
